<template>
  <div class="navbar">
    <hamburger
      :toggle-click="toggleSideBar"
      :is-active="sidebar.opened"
      class="hamburger-container"
    />

    <breadcrumb class="breadcrumb-container"/>

    <div class="right-menu">
      <template v-if="device!=='mobile'">
        <!-- <error-log class="errLog-container right-menu-item hover-effect"/> -->
        <!-- <span class="right-menu-item-btn hover-effect" @click="download()">公司架构</span> -->
        <span class="jump" @click="openBusiness">需求预估工时操作说明</span>
        <span class="jump" @click="jump(0)">员工KPI计算分数算法</span>
        <span class="jump" @click="jump(1)">需求得分算法（部门需求得分）</span>
        <span class="jump" @click="jump(2)">技术中心报告&文档</span>
        <span class="jump" @click="linkTo">对接人查看</span>
        <router-link target="_blank"
        class="right-menu-item-btn hover-effect"
              :to="{path:'/pdfView'}">
              公司系统结构
            </router-link>
        <screenfull class="right-menu-item hover-effect"/>

        <lang-select class="right-menu-item hover-effect"/>
      </template>

      <el-dropdown
        class="avatar-container right-menu-item hover-effect"
        trigger="click">
        <div>
          <svg-icon icon-class="right-upper-user"/>
          {{ language==='zh'?name:nameEn }}
          <i
            class="el-icon-arrow-down"
          />
        </div>
        <el-dropdown-menu slot="dropdown">
          <router-link to="/">
            <el-dropdown-item>{{ $t('navbar.dashboard') }}</el-dropdown-item>
          </router-link>
          <!-- <el-dropdown-item divided>
            <span
              style="display:block;"
              @click="logout">{{ $t('navbar.logOut') }}</span>
          </el-dropdown-item> -->
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import Screenfull from '@/components/Screenfull'
import LangSelect from '@/components/LangSelect'


export default {
  components: {
    Breadcrumb,
    Hamburger,
    Screenfull,
    LangSelect
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters(['sidebar', 'name', 'nameEn', 'avatar', 'device', 'language'])
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('toggleSideBar')
    },
    logout() {
      this.$store.dispatch('LogOut').then(() => {
        window.close()
      })
    },
    download() {
      // window.open(location.origin + '/static/doc/company.pdf')
    },
    jump(val){
      const links = [
        'https://doc.suntekcorps.com/wiki/article/dd501d2f0af703fc0fe787307b48391b',
        'https://doc.suntekcorps.com/wiki/article/af80cdd9c7dae39f7edf280eaa5cae95',
        'https://doc.suntekcorps.com/wiki/article/33e5fd2aa24ba9d5d2c2600ba8467f93'
      ]
      window.open(links[val])
    },
    openBusiness() {
      window.open('https://p1oc8b34mgk.feishu.cn/docx/BWnJdn0gFoyUUkxA7sJc9uB7nre', '_blank')
     },
    linkTo() {
      window.open('https://ex85tje5kz.feishu.cn/sheets/shtcniMOyqaO95NiC3ewWpmtfVe?sheet=WCY5bG', '_blank')
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  height: 50px;
  overflow: hidden;

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;
    position: relative;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }
    .right-menu-item-btn {
            display: inline-block;
            padding: 0 8px;
            height: 100%;
            font-size: 16px;
            color: #6d9eeb;
            vertical-align: text-bottom;
            text-shadow: 5px 5px 20px;

            &.hover-effect {
                cursor: pointer;
                transition: color 0.3s;

                &:hover {
                    color: rgb(27, 122, 218);
                }
            }
        }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
    .jump {
      display: inline-block;
      padding: 0 8px;
      font-size: 14px;
      color: #F56C6C;
      height: 100%;
      vertical-align: text-bottom;
      cursor: pointer;
    }
  }
}
</style>
